import { render, staticRenderFns } from "./EvaluacionComponent.vue?vue&type=template&id=5257edde&scoped=true"
import script from "./EvaluacionComponent.vue?vue&type=script&lang=js"
export * from "./EvaluacionComponent.vue?vue&type=script&lang=js"
import style0 from "./EvaluacionComponent.vue?vue&type=style&index=0&id=5257edde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5257edde",
  null
  
)

export default component.exports